import { makeActionCreator } from '../../config/store/utils'

export const GET_FINAL_BENEFICIARIES_AFFIDAVIT = 'GET_FINAL_BENEFICIARIES_AFFIDAVIT'
export const GET_FINAL_BENEFICIARIES_AFFIDAVIT_ERROR = 'GET_FINAL_BENEFICIARIES_AFFIDAVIT_ERROR'
export const GET_FINAL_BENEFICIARIES_AFFIDAVIT_SUCCESS = 'GET_FINAL_BENEFICIARIES_AFFIDAVIT_SUCCESS'
export const onGetFinalBeneficiariesAffidavit = makeActionCreator(GET_FINAL_BENEFICIARIES_AFFIDAVIT)
export const onGetFinalBeneficiariesAffidavitError = makeActionCreator(
  GET_FINAL_BENEFICIARIES_AFFIDAVIT_ERROR,
  'payload'
)
export const onGetFinalBeneficiariesAffidavitSuccess = makeActionCreator(
  GET_FINAL_BENEFICIARIES_AFFIDAVIT_SUCCESS,
  'payload'
)
